import { getDatasWithOption, handleApiError } from '../../../utils/service';
import { isDefined, isFunction, not, isNotDefined, truthy, falsy, parseInt10, getUriParams, getUriCombinedParams, anyOf, getFirstObjectHasProperty } from '../../../utils/util';
import { ALERT } from '../../../model/msg/alert';
import { API_DOMAIN_DEFAULT } from '../../../model/model';
import DropdownLayer from '../../../vendor/nccommunity/DropDownLayer'; // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/DropDownLayer.js

class ServerWrite {
  constructor(options) {
    const _ = this;

    if (isNotDefined(options)) throw new Error('ServerWrite constructor require options object');

    // _.GAP_SERVER_ID = 47; // opdev: 50, rc: 47

    _.option = $.extend({
      wrap: null,
      apiDomain: '' || API_DOMAIN_DEFAULT,
      hostApiDomain: '' || API_DOMAIN_DEFAULT,
      ncCommunityWrite: null,
      isIngame: false,
      serverAlias: 1,
      serverName: null,
      global: window
    }, options);

    _.global = _.option.global;

    _.wrap = _.option.wrap;

    _.serverId = parseInt10(_.option.serverAlias);
    _.serverName = _.option.serverName;

    _.serverMasterDropdown = null;

    _.ncCommunityWrite = _.option.ncCommunityWrite;

    _.msg = {
      NO_SERVER_ID: '글을 등록할 서버를 찾을 수 없습니다.',
      NOT_MASTER_IN_SERVER: '이 캐릭터는 해당 서버의 서버지기가 아닙니다.'
    };

    _.isEdit = false;
  }

  init() {
    const _ = this;

    if (isNotDefined(_.option.ncCommunityWrite)) throw new Error('ServerWrite constructor require options has ncCommunityWrite parameter');

    // after initialize ncCommunityWrite, call setInstance method
    _.option.ncCommunityWrite.onLoaded.add(_.setInstance, _);

    return _;
  }

  setInstance(writeData) {
    // 1. write new : undefined
    // 2. rewrite(edit) : { title, contents, serverMaster }

    const _ = this;

    // there is item which server master have written
    if (truthy(_.option.isIngame)) {
      // ingame - no process

    } else {
      // pc, mobile

      // api - http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=97027727
      getDatasWithOption([{
        type: 'GET',
        url: `${_.option.hostApiDomain}api/servermaster/${_.serverId}/isServerMaster`,
        dataType: 'json',
        xhrFields: {withCredentials: true}

      }], (data) => {
        console.log('isServerMasterSuccess :', data);

        // if user character is server master
        if (isDefined(data) && data.result === true) {
          // append server master dropdown
          _.setServerMasterDropdown();

          if (isNotDefined(writeData)) {
            console.log('write new article : ', writeData);

            _.serverMasterDropdown.setTextValue('일반');

          } else {
            console.log('rewrite article (edit) :', writeData);
            _.isEdit = true;

            if (writeData.serverMaster) { // 202005
              // server master have written
              _.serverMasterDropdown.setTextValue('서버지기');

            } else {
              // normal
              _.serverMasterDropdown.setTextValue('일반');
            }
          }
        }

      }, (data) => {
        handleApiError(data);
      });
    }
  }

  setServerMasterDropdown() {
    const _ = this,
      dropdownWrap = $('<div class="board-write__category"></div>');

    $('.board-write-title').before(dropdownWrap);

    _.serverMasterDropdown = new DropdownLayer(dropdownWrap, [
      {'key': 'normal', value: '일반'},
      {'key': 'servermaster', value: '서버지기'}
    ], 'boardServerMaster');
  }

  setServerDropdown() {
	  const _ = this;
	  const userData = global.userData || null;

		  let selectedOption = null,
			  dropdownCategoryId = null,
			  dropdownServerName = null;

		  if (anyOf($('body').hasClass('mobile'), $('body').hasClass('tablet'))) {
			  // mobile device
			  selectedOption = $('#boardWriteForm .ui-dropdown-elements select option:selected');
			  dropdownCategoryId = selectedOption.val();
			  dropdownServerName = selectedOption.text()

		  } else {
			  // pc device
			  const dropdownOptions = $('#boardWriteForm .ui-dropdown-community .option li');
			  dropdownServerName = $('#boardWriteForm .board-write-category .ui-dropdown-community .select > span').text();

			  for (let i = 0, max = dropdownOptions.length; i < max; i++) {
				  if ($(dropdownOptions.get(i)).attr('data-textValue') === dropdownServerName) {
					  selectedOption = $(dropdownOptions.get(i));
					  break;
				  }
			  }

			  console.log('selectedOption : ', selectedOption, selectedOption.attr('data-textValue'), selectedOption.attr('data-value'));

			  dropdownCategoryId = selectedOption.attr('data-value');
			  dropdownServerName = selectedOption.attr('data-textValue');
		  }


		  if (isNotDefined(userData) || falsy(userData.isLogin)) return;
		  if (userData.gameAccount.serverName != dropdownServerName) {
			  _.global.alert(_.msg.NO_SERVER_ID); // '글을 등록할 서버를 찾을 수 없습니다.'
			  return false;
		  }

		  return true;


  }

  submitWriteData(data) {
    const _ = this;

    let sendData = null;

    if (truthy(_.option.isIngame)) {
      // ingame
      sendData = data;

      if (isDefined(_.option.ncCommunityWrite)) _.option.ncCommunityWrite.onSubmit(sendData);

    } else {
      // pc, mobile
      sendData = $.extend(true, {
        servermaster: (isDefined(_.serverMasterDropdown) && _.serverMasterDropdown.getValue() === 'servermaster') ? true : false
      }, data);

      console.log('sendData :', sendData);

      // check character is server's server master.
      if (! _.isEdit && isDefined(_.serverMasterDropdown) && _.serverMasterDropdown.getValue() === 'servermaster') {
        // 서버지기 dropdown 이 '서버지기' 로 선택되어 있을 때

		 // if(! _.setServerDropdown()) return;


		  /*
        let selectedOption = null,
          dropdownCategoryId = null,
		  dropdownServerName = null;

        if (anyOf($('body').hasClass('mobile'), $('body').hasClass('tablet'))) {
          // mobile device
          selectedOption = $('#boardWriteForm .ui-dropdown-elements select option:selected');
          dropdownCategoryId = selectedOption.val();
		  dropdownServerName = selectedOption.text()

        } else {
          // pc device
			const dropdownOptions = $('#boardWriteForm .ui-dropdown-community .option li');
			dropdownServerName = $('#boardWriteForm .board-write-category .ui-dropdown-community .select > span').text();

          for (let i = 0, max = dropdownOptions.length; i < max; i++) {
            if ($(dropdownOptions.get(i)).attr('data-textValue') === dropdownServerName) {
              selectedOption = $(dropdownOptions.get(i));
              break;
            }
          }

          console.log('selectedOption : ', selectedOption, selectedOption.attr('data-textValue'), selectedOption.attr('data-value'));

          dropdownCategoryId = selectedOption.attr('data-value');
		  dropdownServerName= selectedOption.attr('data-textValue');
        }

		const userData = global.userData || null;

		if (isNotDefined(userData) || falsy(userData.isLogin)) return;
		if(userData.gameAccount.serverName != dropdownServerName){
			_.global.alert(_.msg.NO_SERVER_ID); // '글을 등록할 서버를 찾을 수 없습니다.'
			return;
		}
		*/

        // api - http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=97027727
        getDatasWithOption([{
          type: 'GET',
          url: `${_.option.hostApiDomain}api/servermaster/${_.serverId}/isServerMaster`,
          dataType: 'json',
          xhrFields: {withCredentials: true}

        }], (data) => {
          console.log('isServerMasterSuccess :', data);

          // if user character is server master
          if (isDefined(data) && data.result === true) {
            console.log('user character is servermaster in this server');

            if (isDefined(_.option.ncCommunityWrite)) _.option.ncCommunityWrite.onSubmit(sendData);
            console.log( ' 서버마스터일경우 : ', sendData );

          } else {
            console.log('user character is not !!! servermaster in this server');

            _.global.alert(_.msg.NOT_MASTER_IN_SERVER); // '이 캐릭터는 해당 서버의 서버지기가 아닙니다.'

            if (isFunction(_.ncCommunityWrite.enableWriteButton)) _.ncCommunityWrite.enableWriteButton();
          }

        }, (data) => {
          handleApiError(data);
        });


      } else {
        // there is not server master dropdown, or user is not server master.
        console.log('there is not server master dropdown, or user is not server master');

        if (isDefined(_.option.ncCommunityWrite)) _.option.ncCommunityWrite.onSubmit(sendData);
      }
    }
  } // submitWriteData()

}

export default ServerWrite;


// WEBPACK FOOTER //
// ./_src/js/board/server/write/ServerWrite.js